// extracted by mini-css-extract-plugin
module.exports = {"colorStatus":"colorCell_colorStatus__2XWFH"};